/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Provider } from '../models/Provider';
import { ResourceType } from '../models/ResourceType';

export class LlgLocationResource {
  /**
  * Eon-assigned resource ID.
  */
  'id': string;
  /**
  * Cloud-provider-assigned resource ID.
  */
  'providerResourceId': string;
  'resourceType': ResourceType;
  'cloudProvider': Provider;
  /**
  * Resource display name.
  */
  'resourceName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceType",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LlgLocationResource.attributeTypeMap;
  }

  public constructor() {
  }
}



